const TeamMemberCard = ({ data }) => (
    <div className="team-member-card">
        <div className="team-member-card__img">
            <img src={data.img} alt={data.name} />
        </div>
        <div className="description-demibold">{data.name}</div>
        <div className="body1">{data.position}</div>
    </div>
);

export default TeamMemberCard;
